<script setup>
// メンテナンス用のステータスコードが返ってくるのでそれが返ってきたら遷移させる
import { ref, inject } from 'vue'
// import { useRouter } from 'vue-router'
// const router = useRouter()

// dummy テキストの使い方合ってるか確認

</script>

<template>
  <section class="l-maintenance">
    <div class="c-maintDesc">
      <p class="c-maintDesc__ttl">
        ただいまメンテナンス中です
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.l-maintenance {
  min-height: 100%;
  background: #EDEDED;
  padding: 16px;

  &__logo {
    width: 139px;
    height: auto;
    margin: 80px auto 50px;
    display: block;
  }
}

.c-maintDesc {
  background: #fff;
  border-radius: 18px;
  padding: 24px 12px;
  border: 1px solid var(--frameColor);
  text-align: center;
  font-size: 1.2rem;

  &__ttl {
    font-weight: var(--fwBold);
    font-size: 1.6rem;
    margin-bottom: 16px;
  }

  &__date {
    font-weight: var(--fwBold);
    font-size: 1.4rem;
    margin-bottom: 16px;
  }
}

</style>
